import {Component, OnInit, ElementRef, HostListener, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, NgClass} from '@angular/common';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';
import {User} from '../../../core/entities/user/user.entity';
import {UserImageComponent} from '../../../core/components/user-image/user-image.component';
import {SubscriptionService} from '../../../core/services/subscription/subscription.service';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {getTagIconFromLabel} from '../../../core/entities/photography/photography-tag.entity';

@Component({
  selector: 'app-user-menu',
  imports: [
    NgClass,
    UserImageComponent,
    TranslocoPipe
],
  templateUrl: './user-menu.component.html',
  standalone: true,
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent implements OnInit {
  public user: User|null = null;
  public isOpen = false;

  public constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
    private readonly subscriptionService: SubscriptionService,
    private readonly translocoService: TranslocoService,
    private readonly elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  public ngOnInit() {
    this.user = this.authenticationService.getCurrentUser();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isOpen = false;
    }
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }

  public getCguHref(): string {
    const lang = this.translocoService.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/photographer/CGU-fr.pdf'
      : '/assets/documents/photographer/ToU-en.pdf';
  }

  public getLegalNoticeHref(): string {
    const lang = this.translocoService.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/mentions-legales.pdf'
      : '/assets/documents/legal-notice.pdf';
  }

  public getPrivacyPolicyHref(): string {
    const lang = this.translocoService.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/politique-de-confidentialite.pdf'
      : '/assets/documents/privacy-policy.pdf';
  }

  public redirectToCustomerPortal(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.subscriptionService.getCustomerPortalLink().subscribe({
      next: (response) => {
        window.location.href = response.url;
      },
    });
  }

  public logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  protected readonly getTagIconFromLabel = getTagIconFromLabel;
}
